import * as React from 'react';
import { Dispatch } from 'react-redux';

import { StoreState } from '../../../../reducers';
import DuplicateTheme from './DuplicateTheme';
import RemoveTheme from './RemoveTheme';
import RenameTheme from './RenameTheme';
import SelectTheme from './SelectTheme';
import ColorsList from './ColorsList';
import { ButtonsWrapper } from './styles';
import { ThemesState } from '../../../../containers/Editor/reducer';

interface ThemesPanelProps {
	themes: ThemesState;
	selectedThemeId: string;
	dispatch: Dispatch<StoreState>;
	className?: string;
}

const ThemesPanel = ({ themes, selectedThemeId, className, dispatch }: ThemesPanelProps) => (
	<div className={className}>
		<SelectTheme
			themes={themes}
			themeId={selectedThemeId}
			dispatch={dispatch}
		/>
		<ColorsList
			themeId={selectedThemeId}
			colors={themes[selectedThemeId].colors}
			dispatch={dispatch}
		/>
		<ButtonsWrapper>
			<RenameTheme
				themeId={selectedThemeId}
				themes={themes}
				className={className}
				dispatch={dispatch}
			/>
			<DuplicateTheme
				themeId={selectedThemeId}
				themes={themes}
				className={className}
				dispatch={dispatch}
			/>
			<RemoveTheme
				themeId={selectedThemeId}
				themes={themes}
				className={className}
				dispatch={dispatch}
			/>
		</ButtonsWrapper>
	</div>
);

export default ThemesPanel;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/EditPanel/ThemesPanel/index.tsx